import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import httpClient from "@/tools/http-client";

const DEFAULT_TOP_COUNT = 5;

export const usePriceItemStore
    = defineStore('PriceItemStore', () => {

    const crud = useCrudStore(environment.appConfig.baseApiUrl + "top-price-list-items");

    async function loadTopPriceItems() {
        console.log("loadTopPriceItems");
        crud.startLoading();
        try {
            const resp = await httpClient.post(
                crud.endpoint.value,
                {top_count: DEFAULT_TOP_COUNT}
            );
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.setData(resp.data.categories);
            crud.clearLoading();
        } catch (e) {
            crud.setError(e);
        }
    }
    return {
        ...crud,
        loadTopPriceItems,
    }
});
